<app-timetable [element]="timetable" *ngFor="let timetable of timetables">
